import React from "react"
import styled from "styled-components"

import useSiteMetadata from "../../use-site-metadata"
import tokens from "../_tokens"

const StyledHero = styled.div`
  background: ${tokens.color.primary};
  width: 100%;
  padding: ${6 * tokens.size.base}px ${7 * tokens.size.base}px;
  height: ${tokens.size.heroHeight}px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  @media (max-width: ${tokens.breakpoint.l}px) {
    height: auto;
    padding: ${4 * tokens.size.base}px ${5 * tokens.size.base}px;
  }
`

const StyledHeading = styled.h2`
  font-size: ${tokens.fontSize.heading.xxl};
  color: ${tokens.color.white};
  margin-top: auto;
  margin-bottom: 0;
  line-height: 2;
  @media (max-width: ${tokens.breakpoint.l}px) {
    font-size: ${tokens.fontSize.heading.xl};
    line-height: 1.5;
  }
`

const StyledText = styled.p`
  margin: 0;
  color: ${tokens.color.white};
  font-size: ${tokens.fontSize.heading.l};
  max-width: 65ch;
  font-weight: 400;
  @media (max-width: ${tokens.breakpoint.l}px) {
    font-size: ${tokens.fontSize.heading.m};
  }
`

function Hero() {
  const { title, description } = useSiteMetadata()

  return (
    <StyledHero>
      <StyledHeading>{title}</StyledHeading>
      <StyledText>{description}</StyledText>
    </StyledHero>
  )
}

export default Hero
